// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xmeF0{padding-inline:8px}._M9Hd{padding-inline:8px;margin-top:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"groupLabel": `xmeF0`,
	"groupLabelSpaced": `_M9Hd`
};
export default ___CSS_LOADER_EXPORT___;
